module.exports = __webpack_public_path__ + "static/img/seven_img06.da9be04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/seven_img06.png
// module id = r5gZ
// module chunks = 6